// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"styles_cardsContainer__dgRF7","card":"styles_card__MCsnZ","badge":"styles_badge__JXMMo"};